const Button = {
  baseStyle: {
    transition: "all .1s ease-in-out",
    fontWeight: "600",
    borderWidth: "1.5px",
    fontSize: "16px",
    bg: "white",
    color: "gray.900",
    _hover: {
      bg: "gray.200"
    },
    _focus: {
      color: "gray.900",
      bg: "blue.500",
      boxShadow: "unset",
      outline: "unset"
    },
    _active: {
      color: "gray.900",
      bg: "blue.500"
    },
    _disabled: {
      _hover: {
        bg: "white !important"
      }
    }
  },
  sizes: {
    sm: {
      fontSize: "md",
      borderRadius: "10px",
      py: 2,
      px: 4,
      height: "unset"
    },
    md: {
      fontSize: "lg",
      borderRadius: "10px",
      py: 3,
      px: 6,
      height: "unset"
    },
    lg: {
      fontSize: "xl",
      borderRadius: "10px",
      py: 4,
      px: 6
    },
    xl: {
      fontSize: "2xl",
      letterSpacing: "0.9px",
      rounded: "xl",
      h: 14,
      minW: 14,
      py: 4,
      px: 12
    }
  },
  variants: {
    outline: {
      borderWidth: "1.5px",
      borderColor: "gray.100",
      bg: "unset",
      _hover: {
        bg: "gray.100",
        color: "gray.900"
      },
      _focus: {
        bg: "gray.100",
        color: "gray.900"
      },
      _active: {
        bg: "gray.100",
        color: "gray.900"
      }
    },
    link: {
      bg: "unset",
      color: "white",
      borderWidth: "0",
      _hover: {
        color: "white",
        textDecoration: "underline",
        bg: "unset"
      },
      _focus: {
        color: "white",
        textDecoration: "underline",
        bg: "unset"
      },
      _active: {
        color: "white",
        textDecoration: "underline",
        bg: "unset"
      },
      _disabled: {
        color: "gray.300",
        textDecoration: "unset",
        bg: "unset",
        _hover: {
          color: "gray.300",
          bg: "unset"
        }
      }
    },
    blue: {
      transition: "all .1s ease-in-out",
      boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
      bg: "blue.500",
      borderColor: "blue.500",
      color: "gray.900",
      _hover: {
        bg: "white",
        borderColor: "white"
      },
      _focus: {
        bg: "white",
        borderColor: "white",
        boxShadow: "outline"
      },
      _active: {
        bg: "white",
        borderColor: "white"
      }
    },
    red: {
      transition: "all .1s ease-in-out",
      boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
      bg: "red.600",
      borderColor: "red.600",
      color: "white",
      _hover: {
        color: "gray.900",
        bg: "white",
        borderColor: "white"
      },
      _focus: {
        color: "gray.900",
        borderColor: "white",
        bg: "white",
        boxShadow: "outline"
      },
      _active: {
        color: "gray.900",
        borderColor: "white",
        bg: "white"
      }
    },
    green: {
      transition: "all .1s ease-in-out",
      boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
      bg: "green.600",
      borderColor: "green.600",
      color: "white",
      _hover: {
        color: "gray.900",
        bg: "green.300",
        borderColor: "green.300"
      },
      _focus: {
        color: "gray.900",
        borderColor: "white",
        bg: "white",
        boxShadow: "outline"
      },
      _active: {
        color: "gray.900",
        borderColor: "white",
        bg: "white"
      }
    },
    dark: {
      transition: "all .1s ease-in-out",
      boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
      bg: "gray.800",
      borderColor: "gray.800",
      color: "white",
      _hover: {
        bg: "gray.800",
        borderColor: "blue.500"
      },
      _focus: {
        color: "white",
        bg: "gray.700"
      },
      _active: {
        color: "white",
        borderColor: "white",
        bg: "gray.700"
      }
    }
  },
  defaultProps: {
    size: "xl",
    variant: "white"
  }
};

export default Button;
